import React, { useEffect, useState } from "react";
import { NavbarApp } from "../../../components";
import { useQuery } from "@tanstack/react-query";
import { getProfile } from "../../../data";
import AuthStore from "../../../stores/AuthStore";
import { Button } from "@/components/ui/button";

export const AppLayout = (props) => {
  const [fistTimeForMount, setFistTimeForMount] = useState(true);
  const { data, isSuccess } = useQuery({
    queryKey: ["profile"],
    queryFn: getProfile,
  });

  useEffect(() => {
    if (isSuccess && data?.data?.user) {
      if (fistTimeForMount) {
        AuthStore.setProfile(data.data.user);
      }
      setFistTimeForMount(false);
    }
  }, [fistTimeForMount, isSuccess, data]);

  if (props.loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <NavbarApp />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 pb-28 md:pb-8">
        {!props.hideHeader && <header className="mb-8 md:flex md:items-center md:justify-between">
          <div className="flex-1 min-w-0">
            <h2 className="text-2xl font-bold leading-7 text-gray-900 dark:text-white sm:text-3xl sm:truncate">
              {props.title}
            </h2>
            {props.description && (
              <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                {props.description}
              </p>
            )}
          </div>
          <div className="mt-4 flex md:mt-0 md:ml-4 space-x-3">
            {props.actions?.map((item, index) => (
              <Button
                key={index}
                onClick={item.onClick}
                variant={item.variant || "default"}
                className={item.className}
              >
                {item.icon && <span className="mr-2">{item.icon}</span>}
                {item.name}
              </Button>
            ))}
          </div>
        </header>}

        <main className="animate-in fade-in duration-300">
          {props.children}
        </main>
      </div>
    </div>
  );
};
